import { render } from "./createcate.vue?vue&type=template&id=11673ccd"
import script from "./createcate.vue?vue&type=script&lang=js"
export * from "./createcate.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__